import React from 'react';
import Button from '../../../../components/Button';
import Image from '../../../../components/Image';
import MaxWidthContainer from '../../../../components/MaxWidthContainer';
import PageSectionTitle from '../../../../components/PageSectionTitle';
import Title from '../../../../components/Title';

import './BusinessSection.scss';

const BusinessSection = ({
  title,
  btnText,
  description,
  heroImgData,
  onCTAClick,
}) => {
  const className = 'c-HomePageContainer-BusinessSection';

  return (
    <div className={className}>
      <div className={`${className}__gradient`}></div>
      <MaxWidthContainer>
        <div className={`${className}__wrapper`}>
          <div className={`${className}__container`}>
            <div className={`${className}__info`}>
              <Title text={title} />
              <PageSectionTitle title={description} />
              <div className="desktop-only">
                <Button displayType="primary" newVersion onClick={onCTAClick}>
                  {btnText}
                </Button>
              </div>
            </div>
            <div className={`${className}__media`}>
              <Image {...heroImgData} />
            </div>
          </div>
          <p className={`${className}__partners__text mobile-only`}>
            We’ve worked with:
          </p>
          <div className={`${className}__partners`}>
            <div
              className={`${className}__partners__container ${className}__partners__pfizer`}
            ></div>
            <div
              className={`${className}__partners__container ${className}__partners__uwc`}
            ></div>
            <div
              className={`${className}__partners__container ${className}__partners__sa`}
            ></div>
            <div
              className={`${className}__partners__container ${className}__partners__nma`}
            ></div>
            <div
              className={`${className}__partners__container ${className}__partners__nyc`}
            ></div>
            <div
              className={`${className}__partners__container ${className}__partners__ncs`}
            ></div>
          </div>
          <div className="mobile-only">
            <Button displayType="primary" newVersion onClick={onCTAClick}>
              {btnText}
            </Button>
          </div>
        </div>
      </MaxWidthContainer>
    </div>
  );
};

export default BusinessSection;
